module.exports = __webpack_public_path__ + "img/join-community.cc741584.svg";